<!-- Status Widgets Settings -->
@if (widgetType === 'STATUS') {
  <div>
    <div class="form-group">
      <span translate>Status event page</span>
      @if (isLoadingStatusEventPages) {
        <span class="fa-solid fa-spinner fa-spin"></span>
      }
      <ng-select [items]="statusEventPagesArray"
        [(ngModel)]="userDefinedWidget.userDefinedChartDetails.statusEventPageName"
        bindLabel="name"
        bindValue="name"
        [placeholder]="selectStatusPagePlaceholder"
        (change)="onStatusEventPageSelect($event)"
               [ngClass]="{
                      'is-invalid': !statusEventPageIsSelected,
                       'is-valid':statusEventPageIsSelected
                       }">
        <ng-template let-item="item" ng-option-tmp>
          <span class="d-block" [innerText]="item.name"></span>
        </ng-template>
      </ng-select>
    </div>
    @if (displayNoStatusPageMessage) {
      <div class="alert alert-info text-center">
        <span translate>Currently no Status page has been added for this machine, please add one and configure it.</span>
      </div>
    }
    <div class="form-group">
      <span translate>Polling rate</span>
      <ng-select (change)="onSetPollingRate($event)"
        [items]="pollingRate"
        [(ngModel)]="selectedPollingRate"
               [ngClass]="{
                     'is-invalid': !isPollingRateValid,
                       'is-valid': isPollingRateValid
                       }"
        [placeholder]="pollingRatePlaceholder"
        bindLabel="pollingRate"
        bindValue="pollingRateInS">
      </ng-select>
    </div>
  </div>
}